import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { SystemUserRole } from '@inshuwa-client/models';

export const loginGuard = () => {
  const nzModalService = inject(NzModalService);
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return false;
  }

  const { role } = decoded;

  if (
    role.toLowerCase() === SystemUserRole.AgentRepresentative.toLowerCase() ||
    role.toLowerCase() === SystemUserRole.AdminAgentRepresentative.toLowerCase()
  ) {
    return true;
  }
  nzModalService.error({
    nzContent: "You're not authorized to access this page",
  });
  return false;
};
